<template>
  <div
    class="all-container"
    v-shortkey.once="shortcut"
    @shortkey="listenShortcut"
  >
    <div class="app-container">
      <div class="app-content">
        <icon-svg />

        <threadList
          @fromChildDialogSelected="handleEmitFromChild"
          @getThread="getThreadList()"
        />

        <chatArea
          :writeMessage.sync="writeMessageSync"
          @toggleChatInfo="onChildToggleChatInfo"
          @search="handleEmitFromChild"
        />

        <userInfo
          @toggleChatInfo="onChildToggleChatInfo"
          @sendCanned="handleEmitFromChild"
        />
      </div>
    </div>
    <WidgetDebug />
  </div>
</template>

<script>
import threadList from "@/components/staff/AthreadList.vue";
import chatArea from "@/components/staff/BchatArea.vue";
import userInfo from "@/components/staff/CuserInfo.vue";
import WidgetDebug from "@/components/widget/WidgetDebug.vue";

import $ from "jquery";
import { mapGetters } from "vuex";
import { staffCookies } from "@/common/mixins/mix_cookies";
import { loader } from "@/common/mixins/mix_loader";
import { snooze, lsConfig, lsUnread } from "@/common/mixins/mix_localStorage";
import { db, Auth } from "@/common/firebase/init";
import {
  alert,
  waktu,
  request,
  rwSound,
  util,
} from "@/common/mixins/mix_helper";
import AppConfig from "@/common/config/app.config.json";
import { thresholdLimitReadMessageByCron } from "@/common/config";
import "bootstrap-notify";
import IconSvg from "@/components/widget/IconSvg";
import indexedDB from "@/common/mixins/mix_indexdb";

export default {
  name: "BaseChat",
  mixins: [
    waktu,
    alert,
    staffCookies,
    request,
    snooze,
    lsConfig,
    rwSound,
    lsUnread,
    util,
    loader,
    indexedDB,
  ],
  components: {
    IconSvg,
    threadList,
    chatArea,
    userInfo,
    WidgetDebug,
  },
  data() {
    return {
      forChildProps: {
        writeMessage: "",
      },
      masterMessages: [], // for filter
      chatInfo: false, // toggle user info
      shortcut: {
        zero: ["ctrl", "0"],
        satu: ["ctrl", "1"],
        dua: ["ctrl", "2"],
        tiga: ["ctrl", "3"],
        empat: ["ctrl", "4"],
        lima: ["ctrl", "5"],
        enam: ["ctrl", "6"],
        tujuh: ["ctrl", "7"],
        delapan: ["ctrl", "8"],
        nine: ["ctrl", "9"],
      },
    };
  },
  methods: {
    startFirebaseListen: async function () {
      this.$rtdb.off();

      const start = performance.now();
      let epochNow = this.getAllVuexAgent._agentLastMessage.time;
      await this.$store
        .dispatch("FbAuthStateChange")
        .then((user) => {
          // --- new thread
          const firebaseAgentThread = db
            .ref(`agents-threads/${user.uid}`)
            .orderByChild("last_time")
            .startAt(epochNow);
          this.$rtdb.on(firebaseAgentThread, "child_added", (item) => {
            let currentAgent = this.cookies.get("staff");
            if (
              typeof currentAgent !== "undefined" &&
              typeof currentAgent.id !== "undefined"
            ) {
              this.appendNewThread(item.val());
            } else {
              this.mixSwalBlock(
                "Maaf, data rw:agent tidak ada silahkan login ulang [child_added]"
              );
            }
          });

          // --- thread update
          const firebaseAgentThreadChanged = db.ref(
            `agents-threads/${user.uid}`
          );
          this.$rtdb.on(firebaseAgentThreadChanged, "child_changed", (item) => {
            let currentAgent = this.cookies.get("staff");
            if (
              typeof currentAgent !== "undefined" &&
              typeof currentAgent.id !== "undefined"
            ) {
              const threadRow = item.val();
              const threadIndex = this.getThreads.all.findIndex(
                (e) => e.id === threadRow.id
              );
              if (threadIndex >= 0) {
                let params = {
                  verified: Boolean(threadRow.verified),
                  email_verified: threadRow.email_verified,
                };
                if (threadRow.is_kb) {
                  params.is_kb = true;
                }

                this.$store.dispatch("DialogUpdate", {
                  index: threadIndex,
                  threadid: threadRow.id,
                  record: params,
                });
              } else {
                // --- ex transfer, undo end thread
                this.appendNewThread(threadRow);
              }
            } else {
              this.mixSwalBlock(
                "Maaf, data rw:agent tidak ada silahkan login ulang [child_changed]"
              );
            }
          });

          // --- new message
          const firebaseAgentMessage = db
            .ref(`agents-messages/${user.uid}`)
            .orderByChild("time")
            .startAt(epochNow);
          this.$rtdb.on(firebaseAgentMessage, "child_added", (item) => {
            let message = item.val();
            if (message.tipe === "action") {
              this.incomingMessage(message, true);
            } else {
              this.incomingMessage(message);
            }
          });

          // -- remove message
          const firebaseRemoveMessage = db
            .ref(`cron-agent/remove-message/${user.uid}`)
            .orderByChild("timeCron")
            .startAt(epochNow);
          this.$rtdb.on(firebaseRemoveMessage, "child_added", (item) => {
            let params = item.val();
            this.getChat.filter((all, index) => {
              if (all.uuid === params.uuid) {
                this.$store.dispatch("staffMessageUpdate", {
                  index: index,
                  record: {
                    message: params.messageDelete,
                  },
                });
              }
            });

            // update thread preview last message
            const threads = this.getThreads.all;
            threads.filter((thread, index) => {
              if (thread.id === params.threadid) {
                if (thread.message === params.message) {
                  this.$store.dispatch("DialogUpdate", {
                    index: index,
                    threadid: thread.id,
                    record: {
                      message: "<i>pesan dihapus</i>",
                    },
                  });
                }
              }
            });
          });

          // --- handle event from admin ex. set away / logout
          const cronRef = db.ref(`cron-agent/${user.uid}`);
          const firebaseCronAgent = cronRef
            .orderByChild("time")
            .startAt(epochNow);
          this.$rtdb.on(firebaseCronAgent, "child_added", async (item) => {
            await this.firebaseHandleCronAgent(item.val());
            await cronRef.remove();
          });
        })
        .catch(async (error) => {
          const end = performance.now();
          await this.$store.dispatch("sendLogAPI", {
            actor: "agent",
            message:
              "Catch FbAuthStateChange token expired request custom token /agent/token",
            agent: JSON.parse(
              localStorage.getItem(AppConfig.rwStorage.agent.agent)
            ),
            error: error,
            time: {
              start: start,
              end: end,
              elapsed: "Time : " + (end - start).toFixed(2) + "ms",
            },
            token: localStorage.getItem(AppConfig.rwStorage.agent.token),
          });

          this.getReloginToken();
        });

      // -- listen server time
      const firebaseServerTime = db.ref("others/server-time");
      this.$rtdb.on(firebaseServerTime, "value", (item) => {
        if (item.val()) {
          let server = item.val();
          if (server) {
            this.$store.dispatch("ServerTime", { time: server.time });
          }
        }
      });
      console.log("listener", this.$rtdb.getListeners());
    },

    /**
     * --------------------------------------------------------------
     * dapatkan token baru untuk login ulang
     * --------------------------------------------------------------
     */
    getReloginToken: function () {
      this.API.get(this.URL.agent.token)
        .then(({ data }) => {
          this.$store
            .dispatch("FbTokenLogin", data.token)
            .then(() => {
              this.loading(false);
              this.startFirebaseListen();
              // this.mixAlert('🚨 PENTING!! URGENT!!', `Lakukan Refresh Halaman!\nAbaikan jika sudah ☺️`);
              // let message = `Masa aktif token Firebase berhasil di <b>perpanjang</b> <br>Lakukan <b>Refresh Halaman</b> jika tidak notifikasi tidak masuk`;
              // this.mixSwalBlock(message, 'Success','success', {showConfirmButton: true, confirmButtonText: "Refresh Halaman"}, () => {
              //   window.location.href = "/agent";
              // });
            })
            .catch(() => {
              this.$swal(
                "Error",
                "Sesi Anda sudah habis, copy pesan terakhir Anda, lalu refresh halaman ini",
                "error"
              );
              this.removeLocalStorage();

              // --- just for report monitoring ---
              this.$store.dispatch("sendLogAPI", {
                actor: "agent",
                message: "Failed to re-generate token firebase /agent/token",
              });
            });
        })
        .catch((err) => {
          if (typeof err.response !== "undefined") {
            if (err.response.status === 401) {
              // force logout
              this.$swal(
                "Error",
                "Sesi anda sudah habis, copy pesan terakhir Anda, lalu refresh halaman ini",
                "error"
              );
              this.cookies.remove();

              // --- just for report monitoring ---
              this.$store.dispatch("sendLogAPI", {
                actor: "agent",
                message: "Failed to get /agent/token API karena status === 401",
              });
            } else {
              let message = err.response.data.message;
              this.mixSwalBlock(message);
              this.cookies.remove();

              // --- just for report monitoring ---
              this.$store.dispatch("sendLogAPI", {
                actor: "agent",
                message: "Failed to get /agent/token API karena status !== 401",
              });
            }
          } else {
            // --- just for report monitoring ---
            this.$store.dispatch("sendLogAPI", {
              actor: "agent",
              message:
                "Failed to get /agent/token API karena err.response === undefined",
            });

            this.mixSwalBlock(err.message);
            this.cookies.remove();
          }
        });
    },

    onChildToggleChatInfo: function () {
      this.chatInfo = !this.chatInfo;
    },

    /**
     * --------------------------------------------------------------
     * for handle emit from child
     * @params {type:String, data: anything }
     * --------------------------------------------------------------
     */
    handleEmitFromChild: function (params) {
      const message = this.forChildProps.writeMessage;
      const draftMessage = this.getDraftById(params.threadid);
      switch (params.type) {
        case "sendCanned":
          this.forChildProps.writeMessage = message + " " + params.data.message;
          break;

        // --- based on click thread
        case "selectThread":
          this.forChildProps.writeMessage = draftMessage?.message || "";

          break;
      }
    },

    /**
     * --------------------------------------------------------------
     * when refresh page, this script will be get thread open in this agent
     * --------------------------------------------------------------
     */
    getThreadList: function () {
      let staff = this.cookies.get("staff");
      if (typeof staff !== "undefined" && typeof staff.id !== "undefined") {
        this.$store
          .dispatch("threadApiGet")
          .then(({ data }) => {
            if (data.length) {
              let appendThread = [];
              data.forEach((thread) => {
                const formatted = this.reformatThreadFromAPI(thread);

                appendThread.push(formatted);
              });
              this.$store.dispatch("DialogSet", appendThread);
            }
          })
          .catch((err) => {
            if (typeof err.response !== "undefined") {
              this.$swal({
                title: "Error",
                html: "Maaf, gagal mengambil percakapan<br>Refresh terlebih dahulu, kalau masih gagal lakukan Re-Login",
                icon: "error",
                confirmButtonText: "Refresh",
                cancelButtonText: "Re-Login",
                showCancelButton: true,
                allowOutsideClick: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload();
                } else {
                  this.cookies.remove();
                  localStorage.removeItem("rw:token");
                  window.location.href = "/auth"; // don't change this, for hard refresh
                }
              });
            } else {
              this.mixSwalBlock(err.message);
            }
          });
      } else {
        this.mixSwalBlock("Sorry, cookies not found.");
      }
    },

    /**
     * --------------------------------------------------------------
     * handle append new thread
     * --------------------------------------------------------------
     */
    appendNewThread: function (item) {
      let currentAgent = this.cookies.get("staff");
      if (item.agents?.includes(currentAgent.id)) {
        let threads = this.getThreads.all;
        if (threads.length === 0 || !this.threadIsExist(item.id)) {
          this.$store.dispatch("DialogAppend", item);
        }
      }
    },

    /**
     * --------------------------------------------------------------
     * cek apakah agent ini memiliki id thread
     * --------------------------------------------------------------
     */
    threadIsExist: function (threadid) {
      return this.getThreads.all.some((e) => String(e.id) === String(threadid));
    },

    /**
     * --------------------------------------------------------------
     * handle pesan baru
     * @params item : respon row from firebase
     * @params pushMessage : jika true tidak append msg melainkan push ex. cron
     * --------------------------------------------------------------
     */
    incomingMessage: function (
      item,
      pushMessage = false,
      is_from_cronjob = false
    ) {
      let roti = this.cookies.get();
      let is_staff_exist =
        typeof roti !== "undefined" &&
        typeof roti.staff !== "undefined" &&
        typeof roti.staff.id !== "undefined";

      if (is_staff_exist) {
        const is_uuid_exist = Object.prototype.hasOwnProperty.call(
          this.getChatLog,
          item.uuid
        );
        if (is_uuid_exist) {
          console.warn(
            `[ignored] message already exist for ${item.uuid} : ${item.message}`
          );
          return false;
        }

        this.$store.dispatch("appendMessageStaffLog", item);

        let agentHasInclude =
          typeof item.agents !== "undefined" &&
          item.agents.includes(roti.staff.id);
        if (agentHasInclude) {
          let actor = item.actor;

          console.warn(
            "Agent new message",
            item.time + ":" + item.message + ":" + item.uuid
          );

          // --- update store for last message
          this.$store.dispatch("agentLastMessage", item);

          // --- showing desktop for included agent
          if (actor === "system" && item.tipe === "agent-close") {
            this.mixAlert("Agent : " + item.name, item.message);
            this.handleThreadClose(item);
          } else {
            let isThreadOpen =
              typeof roti.threadOpen !== "undefined" &&
              typeof roti.threadOpen.id !== "undefined" &&
              roti.threadOpen.id === item.threadid;

            let paramUpdateThread = {
              time: this.mixEpoch(),
              reply: false,
              unread: true,
              agents: item.agents,
              message: item.message,
              alertAway: false,
              subid: item.subthreadid,
            };

            // --- handle message from customer or other staff
            let staffid_firebase = parseInt(item.staffid);
            let staffid_local = parseInt(roti.staff.id);
            if (
              actor !== "staff" ||
              (actor === "staff" && staffid_firebase !== staffid_local)
            ) {
              if (actor === "customer") {
                this.$store.dispatch("AIDebounceAutoDraft", {
                  threadId: item.threadid,
                  subThreadId: item.subthreadid,
                });
              }

              let preFix = actor === "staff" ? "Agent : " : "";

              // --- update thread based on new message
              const thread_index = this.threadIndex(item.threadid);
              if (thread_index >= 0) {
                if (actor === "customer") {
                  paramUpdateThread.name = item.name;
                }

                this.$store.dispatch("DialogUpdate", {
                  index: thread_index,
                  threadid: item.threadid,
                  record: paramUpdateThread,
                });
              } else {
                // --- append thread jika tidak ada
                this.$store
                  .dispatch("threadApiGet", { id: item.threadid })
                  .then(({ data }) => {
                    const thread = this.reformatThreadFromAPI(data);
                    thread.message = item.message;
                    thread.time = this.mixEpoch();
                    thread.reply = false;
                    thread.unread = true;
                    this.appendNewThread(thread);
                  })
                  .catch((error) => {
                    console.error("Failed to append incoming thread:", error);
                  });
              }

              // --- adjust notif sound and handle callback notif
              let callback = (opt) => {
                if (typeof opt.threadid !== "undefined") {
                  this.$store.dispatch("getMessage", {
                    get: true,
                    threadid: opt.threadid,
                  });
                }
              };
              let name = preFix + item.name;
              const status = this.getAllVuexAgent._isOnline;
              let soundCode =
                item.tipe === "agent-join" ? "tf" : status ? "in" : "sa";
              this.mixAlert(name, item.message, soundCode, callback, item);

              // -- for thread opened : append new message, remove top message & set read api
              if (isThreadOpen) {
                this.$store.dispatch("staffAppendNewMessage", item);
                this.$store.dispatch("removeFirstMessage");
              }
            }

            // --- handle message agent trigger by api ex action as agent
            if (item.actor === "staff") {
              this.$store.commit("clearAIQueueAutodraft", {
                threadId: item.threadid,
              });
              const thread_index = this.threadIndex(item.threadid);
              if (thread_index >= 0) {
                paramUpdateThread.reply = true;
                paramUpdateThread.unread = false;
                this.$store.dispatch("DialogUpdate", {
                  index: thread_index,
                  threadid: item.threadid,
                  record: paramUpdateThread,
                });
              }
            }

            if (isThreadOpen) {
              let index_message = this.getChat.findIndex(
                (e) => e.uuid === item.uuid
              );
              if (
                (actor === "staff" &&
                  staffid_firebase === staffid_local &&
                  pushMessage) ||
                index_message === -1
              ) {
                this.$store.dispatch("staffAppendNewMessage", item);
                this.$store.dispatch("removeFirstMessage");
              } else {
                this.$store.dispatch("staffMessageUpdate", {
                  index: index_message,
                  record: item,
                });
              }

              setTimeout(() => {
                this.scrollToBottomChat();
              }, 500);

              // --- remove thread if agent has leaved the thread
              if (item.tipe === "agent-leave") {
                this.$store.dispatch("removeActiveAgent", item.agents);
              }
            }

            // --- set read
            if (item.staffid !== staffid_local) {
              this.$store.dispatch("staffSetRead", {
                subid: item.subthreadid,
                uid: item.uuid,
                by: is_from_cronjob ? "cron" : "firebase",
              });
            }

            // --- delay for waiting DOM update
            setTimeout(() => {
              this.$store.dispatch("DialogMove", { move: true });
            }, 400);
          }
        }
      } else {
        this.mixSwalBlock(
          "rw:agent not found. <br> <small>Please clear localStorage and re login again</small>"
        );
      }
    },

    /**
     * --------------------------------------------------------------
     * jika ada message tipe agent-close
     * cek jika message threadid == cokkies thread open maka close panel chat
     * --------------------------------------------------------------
     */
    handleThreadClose: function (message) {
      const staff = this.cookies.get();
      if (typeof message.threadid !== "undefined") {
        if (typeof staff.threadOpen !== "undefined") {
          if (message.threadid === staff.threadOpen?.id) {
            this.$store.dispatch("toggleUserShow", { show: false });
            this.$store.dispatch("removeDialogActive");
          }
        }
        this.$store.dispatch("DialogRemove", {
          threadid: message.threadid,
        });
      }
    },

    /**
     * --------------------------------------------------------------
     * inisialisasi supaya localStorage === vuex ketika reload page
     * --------------------------------------------------------------
     */
    initSyncSnoozeJSandVuex() {
      let snoozeJS = this.mixGetSnooze();
      if (
        typeof snoozeJS !== "undefined" &&
        typeof snoozeJS.record !== "undefined" &&
        typeof snoozeJS.alert !== "undefined"
      ) {
        this.$store.dispatch("SnoozeSet", snoozeJS);
      }
    },

    /**
     * --------------------------------------------------------------
     * for sync unread thread when agent reload page
     * --------------------------------------------------------------
     */
    initSyncUnreadThread(threadid) {
      let unreadJS = this.mixUnreadGet();
      if (unreadJS !== null) {
        return unreadJS.includes(threadid);
      }
      return false;
    },

    /**
     * --------------------------------------------------------------
     * notif when snooze time over
     * --------------------------------------------------------------
     */
    notifySnoozeTimeOver(message = "", title = "Snooze Time Over : ") {
      $.notify(
        {
          title: `<b>${title}</b>`,
          message: message,
        },
        {
          type: "danger",
          delay: 8000,
          newest_on_top: true,
        }
      );
      //this.mixSound();
    },

    /**
     * --------------------------------------------------------------
     * for handle crontab
     * --------------------------------------------------------------
     */
    handleCronTab: function ({ exec_date }) {
      let epochNow = this.mixEpoch();
      console.warn("getStartCron:" + this.getStartCron);
      if (this.getStartCron < 1) {
        console.warn("1st cron skipped");
        this.$store.dispatch("startCron");
        return true;
      }

      console.warn(`Cron is running at : ${exec_date}`);

      this.$store.dispatch("DialogMove", { move: true });
      this.$store.dispatch("DialogUpTime", { now: epochNow });

      // --- check snooze
      let snooze = this.mixGetSnooze();
      if (snooze) {
        snooze.record.forEach((val) => {
          if (val.timeShow <= epochNow) {
            this.notifySnoozeTimeOver(
              `A reminder for the chat <b>${val.customerName}</b>, please check it`
            );
            this.removeSnooze(val.threadId);
            this.$store.dispatch("SnoozeRemove", val.threadId);
          }
        });
      }

      // --- push desktop notif for dialog away
      this.getThreads.all.forEach((thread, index) => {
        let ago = this.mixGetAgo(thread.time);
        if (
          ago >= this.storage.time_away &&
          thread.reply &&
          !thread.alertAway
        ) {
          this.mixAlert(
            "Thread Away",
            `The thread ${thread.name} enters away mode.`
          );
          this.$store.dispatch("DialogUpdate", {
            index: index,
            record: { alertAway: true },
          });
        }
      });

      // --- compare time local & server
      this.compareTimeLocalServer();

      this.$store.dispatch("startCron");

      // --- get unread message
      this.getMessageUnread();

      return true;
    },

    /**
     * --------------------------------------------------------------
     * compare time server with local
     * --------------------------------------------------------------
     */
    compareTimeLocalServer() {
      let vuex = this.getVuexGeneral._server_time;
      let timeServer = vuex.time;
      let timeLocal = this.mixEpoch();
      let diff = Math.abs(timeServer - timeLocal);
      let getDiffTime = AppConfig.diffAlertDCinSecond;
      if (typeof getDiffTime !== "undefined" && diff > getDiffTime) {
        this.$store.dispatch("connected", { firebase: false });
      } else {
        this.$store.dispatch("connected", { firebase: true });
      }
    },

    /**
     * --------------------------------------------------------------
     * untuk trigger gesture sound supaya bunyi
     * kenapa sessionStorage : supaya terhapus setelah tutup browser
     * --------------------------------------------------------------
     */
    showAlertGestureSound() {
      if (typeof Storage !== "undefined") {
        let name = "gestureSound";
        let flag = sessionStorage.getItem(name);
        if (flag === null) {
          sessionStorage.setItem(name, "init");
        } else {
          this.$swal({
            title: "Warning",
            html: "Anda telah melakukan reload halaman.<br>Silahkan klik tombol <b>Lanjutkan</b>",
            icon: "warning",
            confirmButtonText: "Lanjutkan",
          });

          let get = sessionStorage.getItem(name);
          if (get === "init") {
            sessionStorage.setItem(name, 1);
          } else {
            sessionStorage.setItem(name, parseInt(get) + 1);
          }
        }
      } else {
        this.$swal(
          "Warning",
          "Sorry, your browser does not support Web Storage",
          "error"
        );
      }
    },

    async firebaseHandleCronAgent(firebaseItem) {
      if (typeof firebaseItem.tipe !== "undefined") {
        // == set away by supervisor
        if (firebaseItem.tipe === "agent-set-away") {
          this.cookies.add({ isOnline: false });
          let message =
            typeof firebaseItem.message !== "undefined"
              ? firebaseItem.message
              : "Your account has been set <b>AWAY</b> by admin.";
          this.mixToast(message, {
            style: { background: "orange" },
            duration: 10000,
          });
          this.$store.commit("toggleIsOnline", false);
        }

        // == kick by supervisor in panel admin
        if (firebaseItem.tipe === "agent-set-offline") {
          this.mixSwalBlock(
            "Your account has been <b>KICKED</b> by admin.<br>Please re-login again.",
            "Kicked",
            "error",
            { showConfirmButton: true, confirmButtonText: "Re-login" },
            async () => {
              this.removeLocalStorage();
              await this.$store.dispatch("FbAuthSignOut");
              await this.$router.push("/auth");
            }
          );
        }
      }
    },

    listenShortcut(e) {
      if (!this.getThreads.all.length) {
        return;
      }

      if (typeof this.getAllVuexAgent._dialogActive.id === "undefined") {
        return;
      }

      let master = this.getAllVuexAgent._shortcutCanned;
      let check = (e) => e in master;
      let text = (i) => master[i].body;

      switch (e.srcKey) {
        case "zero":
          if (check("ctrl+0")) {
            this.forChildProps.writeMessage = text("ctrl+0");
          }
          break;
        case "satu":
          if (check("ctrl+1")) {
            this.forChildProps.writeMessage = text("ctrl+1");
          }
          break;
        case "dua":
          if (check("ctrl+2")) {
            this.forChildProps.writeMessage = text("ctrl+2");
          }
          break;
        case "tiga":
          if (check("ctrl+3")) {
            this.forChildProps.writeMessage = text("ctrl+3");
          }
          break;
        case "empat":
          if (check("ctrl+4")) {
            this.forChildProps.writeMessage = text("ctrl+4");
          }
          break;
        case "lima":
          if (check("ctrl+5")) {
            this.forChildProps.writeMessage = text("ctrl+5");
          }
          break;
        case "enam":
          if (check("ctrl+6")) {
            this.forChildProps.writeMessage = text("ctrl+6");
          }
          break;
        case "tujuh":
          if (check("ctrl+7")) {
            this.forChildProps.writeMessage = text("ctrl+7");
          }
          break;
        case "delapan":
          if (check("ctrl+8")) {
            this.forChildProps.writeMessage = text("ctrl+8");
          }
          break;
        case "nine":
          if (check("ctrl+9")) {
            this.forChildProps.writeMessage = text("ctrl+9");
          }
          break;
      }
    },

    scrollToBottomChat: function () {
      let el = $(".qcw-comments.isReading");
      if (el.length) {
        el.animate(
          {
            scrollTop: el[0].scrollHeight,
          },
          1000
        );
      }
    },

    threadIndex: function (threadid) {
      return this.getThreads.all.findIndex((thread) => thread.id === threadid);
    },

    removeLocalStorage() {
      Object.keys(AppConfig.rwStorage.agent).forEach((key) => {
        localStorage.removeItem(AppConfig.rwStorage.agent[key]);
      });
    },

    reformatThreadFromAPI(thread) {
      let ago = this.mixGetAgo(thread.time);
      let is_unread = this.initSyncUnreadThread(thread.id);

      if (!is_unread && !thread.reply) {
        is_unread = true;
        this.mixUnreadPush(thread.id);
      }

      thread["now"] = this.mixEpoch();
      thread["alertAway"] = ago >= this.storage.time_away && thread.reply;
      thread["unread"] = is_unread;

      return thread;
    },

    /**
     * --------------------------------------------------
     * handle cronjob get unread message or new thread
     * --------------------------------------------------
     */
    getMessageUnread() {
      this.$store.dispatch("staffGetUnreadMessage").then((unreads) => {
        // --- looping unread aka @thread
        unreads.forEach(async (unread) => {
          // --- if thread is closed
          if (typeof unread.is_closed !== "undefined" && unread.is_closed) {
            const closeMessage = unread.messages.find(
              (message) => message.tipe === "agent-close"
            );
            if (typeof closeMessage !== "undefined") {
              this.mixAlert("System", closeMessage?.message || "Thread closed");
              this.handleThreadClose(closeMessage);
            }

            // --- set read
            await unread.messages.forEach((item) => {
              this.$store.dispatch("staffSetRead", {
                subid: item.subthreadid,
                uid: item.uuid,
                by: "cron-thread_closed",
              });
            });
            return;
          }

          // --- append new thread if not exist
          const isExist = this.getThreads.all.findIndex(
            (thread) => thread.id === unread.id
          );
          if (isExist === -1) {
            await this.$store
              .dispatch("threadApiGet", { id: unread.id })
              .then(({ data }) => {
                const thread = this.reformatThreadFromAPI(data);
                this.appendNewThread(thread);
              })
              .catch((error) => {
                console.error(error);
              });
          }

          // --- looping message thread unread
          unread.messages.forEach((message) => {
            const is_message_exist = Object.prototype.hasOwnProperty.call(
              this.getChatLog,
              message.uuid
            );

            // --- message is exist
            if (is_message_exist) {
              this.$store.dispatch("staffSetRead", {
                subid: message.subthreadid,
                uid: message.uuid,
                by: "cron-message_exist",
              });
            }

            // --- message is not exist
            else {
              if (message.tipe === "action") {
                this.incomingMessage(message, true, true);
              } else {
                this.incomingMessage(message, false, true);
              }
              this.$store.commit("incrementReadByCRON");
            }
          });
        });

        if (this.getIncrementReadByCRON > thresholdLimitReadMessageByCron) {
          this.mixAlert(
            "System",
            "Kualitas koneksi kurang stabil. Silakan refresh halaman livechat untuk memastikan layanan berjalan dengan optimal",
            "net-tm",
            null,
            { icon: "img/warning.png" }
          );
        }
      });
    },
  },
  computed: {
    ...mapGetters([
      "getThreads",
      "getChat",
      "getChatLog",
      "getAllVuexAgent",
      "getStartCron",
      "getVuexGeneral",
      "getDialogActive",
      "getDraftById",
      "getIncrementReadByCRON",
    ]),
    storage: function () {
      return this.mixConfigGetter();
    },
    writeMessageSync: {
      get() {
        return this.forChildProps.writeMessage;
      },

      set(value) {
        this.forChildProps.writeMessage = value;

        this.$store.commit("draftUpdate", {
          threadid: this.getDialogActive.id,
          message: value,
          is_edited_by_staff: !!(value && value.trim() !== ""),
        });
      },
    },
    activeDraftMessage() {
      const activeDialog = this.getDialogActive;
      if (!activeDialog || !activeDialog.id) return "";
      const draft = this.getDraftById(activeDialog.id);
      return draft ? draft.message : "";
    },
  },
  watch: {
    activeDraftMessage(newVal) {
      if (newVal !== undefined && newVal !== this.forChildProps.writeMessage) {
        this.forChildProps.writeMessage = newVal;
      }
    },
  },
  async mounted() {
    await this.$store.dispatch("ShortcutCanned");

    this.getThreadList();
    this.initSyncSnoozeJSandVuex();
    this.showAlertGestureSound();

    // --- req agent bubble color
    await this.$store.dispatch("BubbleColor");

    localStorage.openpages = Date.now();
    let onLocalStorageEvent = function (e) {
      if (e.key === "openpages") {
        localStorage.page_available = Date.now();
      }
      if (e.key === "page_available") {
        window.location = `/panel/restrict?tm=${e.newValue}`;
      }
    };
    window.addEventListener("storage", onLocalStorageEvent, false);

    await Auth.onIdTokenChanged(async (token) => {
      if (token) {
        token = token.toJSON();

        const name = "rw:authtime";
        const expiryTime = Math.floor(
          token.stsTokenManager.expirationTime / 1000
        );

        let data = localStorage.getItem(name);
        if (data) {
          data = JSON.parse(data);
          if (!data.expiryTimes.includes(expiryTime)) {
            data.expiryTimes.push(expiryTime);
          }
        } else {
          data = {
            loginAt: Math.floor(token.lastLoginAt / 1000),
            expiryTimes: [expiryTime],
          };
        }

        localStorage.setItem(name, JSON.stringify(data));
        console.log("authTimes", data);
      } else {
        const agent = JSON.parse(
          localStorage.getItem(AppConfig.rwStorage.agent.agent)
        );
        const firebaseIndexDB = await this.firebase_indexedDB();
        const firebaseTokenIndexDB =
          firebaseIndexDB?.value?.stsTokenManager.accessToken;

        await this.$store.dispatch("sendLogAPI", {
          actor: "agent",
          message:
            "Auth.onIdTokenChanged firebase token is null, request custom token /agent/token",
          agent: `${agent?.staff?.name || "-"} - ${agent?.staff?.email || "-"}`,
          firebaseToken: firebaseTokenIndexDB,
          expiry: JSON.parse(localStorage.getItem("rw:authtime")),
        });

        this.getReloginToken();
      }
    });

    // --- cronjob every 1 minute
    this.$crontab.addJob({
      name: "counter",
      interval: {
        seconds: "30",
      },
      job: this.handleCronTab,
    });
  },
  created() {
    this.startFirebaseListen();

    window.addEventListener("beforeunload", function (e) {
      e.preventDefault();
    });
  },
};
</script>

<style>
@import "../assets/qiscus/menu.css";
@import "../assets/qiscus/main.css";
@import "../assets/qiscus/qiscus-sdk.2.10.0.css";
@import "../assets/qiscus/inbox.css";
@import "../assets/qiscus/flex.css";
@import "../assets/qiscus/override.css";
@import "../assets/qiscus/simplemde.min.css";
@import "../assets/css/rw-custom.css";
.all-container {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  height: 100%;
}
</style>

<style scoped>
@import url("~bootstrap/dist/css/bootstrap.min.css");
</style>
